import styled from 'styled-components';
export const StyledResultHead = styled.div`
  background-color: ${(props) => props.theme.resultHead_BG} !important;
  color: ${(props) => props.theme.resultHead_text} !important;
`;

export const StyledResulsFT = styled.span`
  color: ${(props) => props.theme.retultFT_text} !important;
`;